import ProductVariant from '../../../domains/ProductVariant'
import { Cart } from '../../../services/cartService/cart.service.types'

export const isLineItemExist = (newCheckout: Cart | undefined, selectedVariant: ProductVariant | undefined) => {
  const lineItem = newCheckout?.lineItems?.find?.(item => item.variantId === selectedVariant?.id)
  const lineItemExist = !!lineItem
  return lineItemExist
}

export const getLineItemIdForVariant = (newCheckout: Cart | undefined, selectedVariant: ProductVariant | undefined) => {
  const lineItem = newCheckout?.lineItems?.find?.(item => item.variantId === selectedVariant?.id)
  return lineItem?.id
}
